import { colorsV2 } from '../../figma/colors-v2';
import { ResponsiveTypography } from '../../figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { numberToABC } from '@doltech/utils/lib/text';
import { flexGap } from '@doltech/utils/lib/css-style';

const Main = styled.div`
  display: flex;
  padding: 4px 8px 4px 4px;
  align-items: center;

  ${flexGap(8)};
  border-radius: 12px;
  border: 1px dashed ${colorsV2.neutral20};
  background: ${colorsV2.white100};

  &.selected {
    border: 1px dashed ${colorsV2.blue100};
  }

  &:hover {
    border: 1px solid ${colorsV2.neutral20};
    &.selected {
      border: 1px solid ${colorsV2.blue100};
    }
  }
  cursor: pointer;
`;

export const AbcBox = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;

  border-radius: 8px;
  background: ${colorsV2.blue100};
`;

interface OptionSelectItemProps {
  index?: number;
  text?: string;
  selected?: boolean;
  withAbc?: boolean;
}

export const OptionSelectItem = (props: OptionSelectItemProps) => {
  const { index, text, selected, withAbc } = props;

  return (
    <Main className={cl({ selected })}>
      {withAbc && (
        <AbcBox>
          <ResponsiveTypography.Paragraph variant="bold/12-16" color={colorsV2.white100}>
            {numberToABC(index + 1)}
          </ResponsiveTypography.Paragraph>
        </AbcBox>
      )}
      <ResponsiveTypography.Paragraph variant="medium/14-20" color={colorsV2.neutralPrimary}>
        {text}
      </ResponsiveTypography.Paragraph>
    </Main>
  );
};
